import { createContext, Dispatch, PropsWithChildren, ReactNode, SetStateAction, useContext, useEffect, useState } from "react";


export interface BreadcrumbsContextType {
  breadcrumbs: ReactNode;
  setBreadcrumbs: Dispatch<SetStateAction<BreadcrumbsContextType['breadcrumbs']>>;
}

export const BreadcrumbsContext = createContext<BreadcrumbsContextType>({
  breadcrumbs: [],
  setBreadcrumbs: () => { },
});

// MUST BE USE ON TOP LEVEL COMPONENT
export const BreadcrumbsContextProvider = ({ children }: PropsWithChildren) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsContextType['breadcrumbs']>();

  return (
    <BreadcrumbsContext.Provider value={{ breadcrumbs, setBreadcrumbs }}>
      {children}
    </BreadcrumbsContext.Provider>
  );
}

// USE TO DISPLAY THE BREADCRUMBS ANYWHERE INSIDE THE PROVIDER
export const BreadcrumbsContainer = (_props: PropsWithChildren) => null;

// USE TO SET THE BREADCRUMBS
export const Breadcrumbs = ({ children }: PropsWithChildren) => {
  const { setBreadcrumbs } = useContext(BreadcrumbsContext);
  useEffect(() => {
    setBreadcrumbs(children);
    return () => {
      setBreadcrumbs(undefined);
    }
  }, [children, setBreadcrumbs]);
  
  return <></>;
}